import * as angular from "angular";
import * as _ from "lodash";
import {IPromise, IQService} from "angular";
import {CustomersAlerts} from "./customers-alerts.service";
import {CustomersRequests} from "./customers-requests.service";
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";

export class CustomerService {

  /* @ngInject */
  constructor(private $q: IQService, private customersRequests: CustomersRequests, private customersAlerts: CustomersAlerts, private bringozLoaderService: BringozLoaderService, private $log) {
  }

  createCustomer(customer): IPromise<any> {
    return new Promise((resolve, reject) => {
      this.bringozLoaderService.on();
      this.customersRequests.createCustomer(customer)
        .then((createdCustomer) => {
          this.customersAlerts.createSuccess();
          resolve(createdCustomer);
        })
        .catch((error) => {
          this.$log.error(error);
          this.customersAlerts.createError();
          reject(error);
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    });
  }

  updateCustomer(customer) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.customersRequests.updateCustomer(customer.id, customer)
      .then((updatedCustomer) => {
        deferred.resolve(updatedCustomer)
        this.customersAlerts.updateSuccess();
      })
      .catch((error) => {
        deferred.reject(error)
        this.customersAlerts.updateError();
        this.$log.info('Failed to update customer', error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })

    return deferred.promise;
  }


  getFullName(fullName) {
    const nameArray = _.words(fullName);
    const lastNameArray = _.filter(nameArray, (name, index) => {
      return index > 0;
    });
    return {
      firstName: nameArray[0],
      lastName: lastNameArray.length ? _.join(lastNameArray, ' ') : nameArray[0]
    }
  }

  addAddress(customerId, address) {
    return new Promise((resolve, reject) => {
      this.bringozLoaderService.on();
      this.customersRequests.addAddress(customerId, address)
        .then((createdAddress) => {
          this.customersAlerts.addAddressSuccess();
          resolve(createdAddress);
        })
        .catch((error) => {
          this.$log.error(error);
          this.customersAlerts.addAddressError();
          reject(error);
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    });
  }

  updateAddress(customerId, customer, originalAddress) {
    return new Promise((resolve, reject) => {
      this.bringozLoaderService.on();
      this.customersRequests.updateCustomer(customerId, customer)
        .then((updatedAddress) => {
          this.customersAlerts.updateAddressSuccess(originalAddress);
          resolve(updatedAddress);
        })
        .catch((error) => {
          this.$log.error(error);
          this.customersAlerts.updateAddressError();
          reject(error);
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    });
  }

  updateDefaultAddress(customerId, addressId): IPromise<any> {
    return new Promise((resolve, reject) => {
      this.bringozLoaderService.on();
      this.customersRequests.updateDefaultAddress(customerId, addressId)
        .then((updatedDefaultAddress) => {
          this.customersAlerts.updateDefaultAddressSuccess();
          resolve(updatedDefaultAddress);
        })
        .catch((error) => {
          this.$log.error(error);

          if (error.status === 404) {
            this.customersAlerts.updateDefaultAddressInfo();
          } else {
            this.customersAlerts.updateDefaultAddressError();
          }

          reject(error);
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    });
  }

  deleteAddress(customerId, addressId, address) {
    return new Promise((resolve, reject) => {
      this.bringozLoaderService.on();
      this.customersRequests.deleteAddress(customerId, addressId)
        .then((deletedAddress) => {
          this.customersAlerts.deleteAddressSuccess(address);
          resolve(deletedAddress);
        })
        .catch((error) => {
          this.$log.error(error);
          this.customersAlerts.deleteAddressError();
          reject(error);
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    });
  }

  getDefaultAddress(customerId): IPromise<any> {
    return new Promise((resolve, reject) => {
      this.bringozLoaderService.on();
      this.customersRequests.getDefaultAddress(customerId)
        .then((defaultAddress) => {
          this.customersAlerts.updateDefaultAddressSuccess();
          resolve(defaultAddress);
        })
        .catch((error) => {
          this.$log.error(error);
          this.customersAlerts.updateDefaultAddressError();
          reject(error);
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    });
  }

  export(exportType, accountIds) {
    return new Promise((resolve, reject) => {
      this.bringozLoaderService.on();
      this.customersRequests.export(exportType, accountIds,)
        .then((updatedAgent) => {
          this.customersAlerts.exportSuccess();
          resolve(updatedAgent);
        })
        .catch((error) => {
          this.$log.error(error);
          this.customersAlerts.exportError();
          reject(error);
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    });
  }


}

angular
  .module('bringoz.admin.customers')
  .service('customerService', CustomerService);
